import styled from 'styled-components';
import { device } from '../breakpoints';
import { VisuallyHidden } from '../utils.styles';
import { playTransitionEasing, iconArrowRight } from '../design-tokens';
import PromotionItem from '../PromotionItem/PromotionItem';
import { playFontIcon } from '../typography/helpers';

export const GridWrapper = styled.section`
    @supports (display: grid) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 5px;
        row-gap: 5px;
        width: 100%;

        @media ${device.GteSmall} {
            grid-template-columns: repeat(4, 1fr);
        }
        @media ${device.GteLarge} {
            grid-template-columns: repeat(6, 1fr);
        }
        @media ${device.FullScreen} {
            grid-template-columns: repeat(8, 1fr);
        }
    }

    /* IE11 */
    display: flex;
    flex-wrap: wrap;
`;

export const Heading = styled.h1`
    ${VisuallyHidden}
`;

export const BumpingArrowIcon = styled.span`
    line-height: normal;
    text-decoration: none;
    margin-left: 5px;
    vertical-align: middle;
    transition: transform 200ms ${playTransitionEasing};
    font-size: 1em;
    margin-top: -1px;

    &:before {
        ${playFontIcon(2, iconArrowRight)}
        vertical-align: baseline;
    }
`;

export const LinkToAll = styled.div`
    width: 100%;
    text-align: center;
    margin: 30px 0 0;

    @media ${device.GteSmall} {
        margin: 20px 0 0;
    }

    &:hover {
        ${BumpingArrowIcon} {
            &:before {
                transform: translateX(4px);
            }
        }
    }
`;

export const GridItem = styled(PromotionItem)`
    @supports (display: grid) {
        width: 100%;
        margin-bottom: 0;
    }

    /* IE 11 */
    width: 25%;
`;
